import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";

const VerifyEmailPage = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("loading"); // loading, success, error
    const redirectTo = searchParams.get("redirect");

    useEffect(() => {
        const token = searchParams.get("token");
        if (!token) {
            setStatus("error");
            return;
        }

        fetch(`${window.REACT_APP_API_ENDPOINT}/auth/verify-email?token=${encodeURIComponent(token)}`, {
            credentials: "include",
        })
            .then((res) => {
                if (res.ok) {
                    setStatus("success");
                    // Full page reload so App.js re-fetches the user session
                    if (redirectTo) {
                        setTimeout(() => {
                            window.location.href = redirectTo;
                        }, 2000);
                    }
                } else {
                    setStatus("error");
                }
            })
            .catch(() => setStatus("error"));
    }, [searchParams, redirectTo]);

    return (
        <div className="container mx-auto px-4 py-16">
            <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8 text-center">
                {status === "loading" && (
                    <>
                        <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-4"></div>
                        <p className="text-gray-500">Verificando tu email...</p>
                    </>
                )}
                {status === "success" && (
                    <>
                        <div className="inline-flex items-center justify-center w-14 h-14 bg-green-100 rounded-full mb-4">
                            <svg className="w-7 h-7 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">Email verificado</h2>
                        <p className="text-gray-500 mb-6">Tu cuenta ha sido verificada correctamente.</p>
                        {redirectTo ? (
                            <p className="text-sm text-gray-400">Redirigiendo...</p>
                        ) : (
                            <Link to="/" className="text-blue-600 hover:underline">Ir al inicio</Link>
                        )}
                    </>
                )}
                {status === "error" && (
                    <>
                        <div className="inline-flex items-center justify-center w-14 h-14 bg-red-100 rounded-full mb-4">
                            <svg className="w-7 h-7 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">Enlace inválido</h2>
                        <p className="text-gray-500 mb-6">El enlace de verificación es inválido o ha expirado.</p>
                        <Link to="/" className="text-blue-600 hover:underline">Ir al inicio</Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default VerifyEmailPage;
